module.exports = __webpack_public_path__ + "static/media/TreeStand.svg";